import { render, staticRenderFns } from "./zona.vue?vue&type=template&id=24e0eaeb&"
import script from "./zona.vue?vue&type=script&lang=js&"
export * from "./zona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QSeparator,QDialog,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QInput,QSeparator,QDialog,QBtn}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
